import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

class LanguageSwitcher extends Component {
	constructor() {
		super();
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.state = {
			isOpened: false
		};
	};

	componentDidUpdate(prevProps, prevState) {
		if (this.state.isOpened && !prevState.isOpened) {
			this.props.setOpened(this.props.type);
		}

		if (this.props.openedElem !== prevProps.openedElem) {
			this.setState({ isOpened: this.props.openedElem === this.props.type });
		}
	};

	componentWillUnmount() {
		document.removeEventListener('click', this.handleOutsideClick, false);
	}

	handleClick() {
		if (!this.state.isOpened) {
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState({ isOpened: !this.state.isOpened });
	}

	handleOutsideClick(e) {
		if (!this.node) return;
		if (this.node.contains(e.target));
		this.handleClick();
	};

	render() {
		const { clang, setLang, availableLanguages } = this.props;
		const { isOpened } = this.state;

		return (
			<div className="header__languages">
				<button className="header__languages-button" onClick={ () => this.handleClick() }>
					{ lang[ clang ][ clang ] }
				</button>
				{ isOpened &&
					<div className="header__languages-dropdown" ref={ node => { this.node = node; } }>
						<span className="header__languages-circle"></span>
						{ availableLanguages.map(langItem =>
							<button key={ langItem } disabled={ clang === langItem } onClick={ () => setLang(langItem) }
								title={ langItem === 'pl' ? lang[ clang ].title.pl_title : lang[ clang ].title.en_title }
								className={ `header__languages-language ${clang === langItem ? 'active' : ''}` }>
								{ langItem === 'pl' ? lang[ clang ].pl : lang[ clang ].en }
								<span className="header__languages-language--line"></span>
								<span className="header__languages-language--img"></span>
							</button>) }
					</div> }

			</div>
		);
	};
};

LanguageSwitcher.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/header/LanguageSwitcher.js